import cx from "classnames";
import { KeyboardEvent, useCallback, useState } from "react";

import Tooltip from "ds/components/Tooltip";

import { ellipsis, quote } from "../constants";
import styles from "../styles.module.css";

const lengthLimit = 40;

const String = ({ children: value }: { children: string }) => {
  const isShortValue = value.length <= lengthLimit;

  const shortValue = value.slice(0, lengthLimit - 4);
  const [displayOriginalValue, setDisplayOriginalValue] = useState(isShortValue);

  const toggleValue = useCallback(() => {
    setDisplayOriginalValue((prev) => !prev);
  }, []);

  const toggleValueKeyboard = useCallback(
    (e: KeyboardEvent) => {
      if (e.code === "Space") {
        toggleValue();
      }
    },
    [toggleValue]
  );

  return (
    <span className={styles.codeChangesString}>
      {quote}
      {displayOriginalValue ? (
        value
      ) : (
        <>
          {shortValue}
          &nbsp;
          <Tooltip
            widthMode="maxWidthSm"
            on={(props) => (
              <span
                className={cx(
                  styles.codeChangesEllipsis,
                  styles.codeChangesFocus,
                  styles.codeChangesExpandString
                )}
                role="button"
                onClick={toggleValue}
                tabIndex={0}
                {...props}
                onKeyDown={toggleValueKeyboard}
              >
                {ellipsis}
              </span>
            )}
          >
            {value}
          </Tooltip>
        </>
      )}
      {quote}
    </span>
  );
};

export default String;
